const MNT_URL = "https://www.mnt.org.rs";
const BGA_URL = "https://bgazrt.hu";

// A Magyar Nemzeti Tanács az üzemeltető és pályázatkiíró, ezért külön áll a
// "Támogató" felirat alá tartozó BGA és minisztériumi logótól.
export const SupportLogos = () => (
  <div className="support-logos">
    <a href={MNT_URL} target="_blank" rel="noopener noreferrer" className="support-logos__owner">
      <img src="/logos/mnt.png" alt="Magyar Nemzeti Tanács" />
    </a>
    <div className="support-logos__funders">
      <span className="support-logos__label">Támogató:</span>
      <a href={BGA_URL} target="_blank" rel="noopener noreferrer" className="support-logos__item support-logos__item--ministry">
        <img
          src="/logos/magyar-kormany-tamogatasaval.jpg"
          alt="Megvalósult a Magyar Kormány támogatásával – Társadalmi Kapcsolatokért és Kultúráért Felelős Minisztérium"
        />
      </a>
      <a href={BGA_URL} target="_blank" rel="noopener noreferrer" className="support-logos__item">
        <img src="/logos/bga-alap.png" alt="Bethlen Gábor Alap" />
      </a>
    </div>
  </div>
);
